import Login from './login'

export enum TypesUser {
    ADMIN = 'admin',
    HEALTH_PROFESSIONAL = 'health_professional',
    NAVIGATOR = 'navigator'
}
export const MAP_TYPE_USER_TO_ENDPOINT = {
    [TypesUser.ADMIN]: 'admins',
    [TypesUser.HEALTH_PROFESSIONAL]: 'healthprofessionals',
    [TypesUser.NAVIGATOR]: 'navigators',
}

export enum TypeGender {
    NOT_OPTED = "not_opted",
  //  OTHERS = "others",
    FEMELE = "female",
    MALE = "male"
}
export enum SearchFilter {
    NAME = "name"
}

export default class User extends Login {
    public static checkEmailRegisteredError(error: { code: number, message: string }): boolean {
        return error &&
            error?.code === EMAIL_REGISTERED_ERROR.code &&
            error?.message === EMAIL_REGISTERED_ERROR.message
    }


    private _id: string | undefined
    private _name: string | undefined
    private _contact: string | undefined
    private _county: string | undefined
    private _last_login: string | undefined
    private _created_at: string | undefined
    private _updated_at: string | undefined
    private _type: TypesUser | undefined
    private _avatar: any | undefined



    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }
    get name(): string | undefined {
        return this._name
    }

    set name(value: string | undefined) {
        this._name = value
    }
    get contact(): string | undefined {
        return this._contact
    }

    set contact(value: string | undefined) {
        this._contact = value
    }

    get county(): string | undefined {
        return this._county
    }

    set county(value: string | undefined) {
        this._county = value
    }
    get last_login(): string | undefined {
        return this._last_login
    }

    set last_login(value: string | undefined) {
        this._last_login = value
    }

    get created_at(): string | undefined {
        return this._created_at
    }

    set created_at(value: string | undefined) {
        this._created_at = value
    }

    get updated_at(): string | undefined {
        return this._updated_at
    }

    set updated_at(value: string | undefined) {
        this._updated_at = value
    }

    get type(): TypesUser | undefined {
        return this._type
    }

    set type(value: TypesUser | undefined) {
        this._type = value
    }

    get avatar(): string | undefined {
        return this._avatar
    }

    set avatar(value: string | undefined) {
        this._avatar = value
    }
    // metodo responsavel por formatar os dados do backend para frontend
    public fromJSON(json: any): User {
        super.fromJSON(json)


        if (json.id !== undefined) {
            this.id = json.id
        }

        if (json.name !== undefined) {
            this.name = json.name
        }
        if (json.contact !== undefined) {
            this.contact = json.contact
        }
        if (json.county !== undefined) {
            this.county = json.county
        }
        if (json.last_login !== undefined) {
            this.last_login = json.last_login
        }

        if (json.created_at !== undefined) {
            this.created_at = json.created_at
        }

        if (json.updated_at !== undefined) {
            this.updated_at = json.updated_at
        }

        if (json.type !== undefined) {
            this.type = json.type
        }

        if (json.avatar !== undefined) {
            this.avatar = json.avatar
        }
        return this
    }

        // metodo responsavel para formatar os dados do front para o back

    public toJSON(): any {
        return {
            ...super.toJSON(),
            id: this.id ? this.id : undefined,
            name: this.name ? this.name : undefined,
            contact: this.contact ? this.contact : undefined,
            county: this.county ? this.county : undefined,
            last_login: this.last_login ? this.last_login : undefined,
            created_at: this.created_at ? this.created_at : undefined,
            updated_at: this.updated_at ? this.updated_at : undefined,
            type: this.type ? this.type : undefined,
            avatar: this.avatar ? this.avatar : undefined
        }
    }

}

export const USER_PROTECTED_ERROR = {
    code: 400,
    message: 'The operation could not be completed as the user in question cannot be removed.'
}

export const EMAIL_REGISTERED_ERROR = {
    code: 409,
    message: 'A user with this email already registered!'
}

export const PATIENT_DISSOCIATE_ERROR = {
    code: 400,
    message: 'Patient cannot be disassociated!',
    description: 'This HealthProfessional is the only one who has an association with this Patient.'
}


